exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".skillsetBanner{position:relative;text-align:center}.skillsetBanner .title{text-align:center;padding-top:20px;margin-bottom:-61px;font-size:2em}.skillsetBanner .title .inner{display:inline-block;max-width:50%;border-bottom:1px solid #ddd;padding:0 5px}.skillsetBanner.largeBanner img.banner{width:60%;height:auto}.skillsetBanner.smallBanner{width:400px}.skillsetBanner.smallBanner .title{padding-top:11px;margin-bottom:-30px;font-size:16px}.skillsetBanner.smallBanner img.banner{width:90%;height:auto}.skillsetBanner .text{text-align:left;margin-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/writing/questions/skillset_banner.scss
// module id = 1525
// module chunks = 0